import { render } from "./App.vue?vue&type=template&id=23025d94"
const script = {}

import "./App.vue?vue&type=style&index=0&id=23025d94&lang=css"

import exportComponent from "C:\\Users\\26494\\Documents\\GitHub\\GitHub\\doge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__